module.exports = __webpack_public_path__ + "static/media/cube.f8d3e529.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/black/cube.svg
// module id = 1392
// module chunks = 0